module.exports = __webpack_public_path__ + "static/media/200.9698bdac.svg";